import { Grid } from '@material-ui/core';
import React from 'react';
import { StringParam, useQueryParam } from 'use-query-params';
import { ProgramManagementSingleProgramBasicInfo } from '../__generated__/ProgramManagementSingleProgramBasicInfo';
import { ProgramBasicInfoSectionForm } from './program-form-sections/ProgramBasicInfoSectionForm';
import {
  ProgramActivitiesSection,
  ProgramActivitiesSectionLocked,
} from './program-form-sections/ProgramActivitiesSection';
import { ProgramManagersSection, ProgramManagersSectionLocked } from './program-form-sections/ProgramManagersSection';
import {
  ProgramVolunteersSection,
  ProgramVolunteersSectionLocked,
} from './program-form-sections/ProgramVolunteersSection';
import {
  ProgramImageUploadSection,
  ProgramImageUploadSectionLocked,
} from './program-form-sections/ProgramImageUploadSection';
import { ProgramApplicationSection } from './program-form-sections/ProgramApplicationSection';
import { useUser } from '../../../../global/auth/useUser';

const EditProgramForm = ({
  programBasicInfo,
}: {
  programBasicInfo: ProgramManagementSingleProgramBasicInfo | undefined;
}) => {
  const [selectedProgramId] = useQueryParam('pid', StringParam);
  const {
    user: {
      userIdentityService: { isVmAdmin },
    },
  } = useUser();

  if (selectedProgramId === 'new' || !programBasicInfo)
    return (
      <Grid container>
        <ProgramBasicInfoSectionForm programBasicInfo={programBasicInfo} />
        <ProgramImageUploadSectionLocked />
        <ProgramActivitiesSectionLocked />
        {isVmAdmin && <ProgramManagersSectionLocked />}
        <ProgramVolunteersSectionLocked />
      </Grid>
    );
  return (
    <Grid container>
      <ProgramBasicInfoSectionForm programBasicInfo={programBasicInfo} />
      <ProgramImageUploadSection />
      <ProgramActivitiesSection programBasicInfo={programBasicInfo} />
      {isVmAdmin && <ProgramManagersSection />}
      <ProgramVolunteersSection />
      {programBasicInfo.isRestrictedProgram && <ProgramApplicationSection />}
    </Grid>
  );
};

export { EditProgramForm };
